﻿// Import axios for API consuming in a clean interface.
const axios = require('axios');

const API_URL = 'https://api.leadinfo.com/v1/identify';
const PLACEHOLDER = '{{placeholder}}';
const FALLBACK = 'uw bedrijf';

document.addEventListener('DOMContentLoaded', async () => {
    const $leadinfoContainers = document.querySelectorAll('.leadinfo');
    if (!$leadinfoContainers.length) return;
    const response = await getCompany();
    $leadinfoContainers.forEach($container => {
        if ($container.innerHTML.includes(PLACEHOLDER)) {
            if (response && response.data.length && response.data.name.length) {
                $container.innerHTML = $container.innerHTML.replace(PLACEHOLDER, response.data.name);
            } else if ($container.dataset.fallback) {
                $container.innerHTML = $container.innerHTML.replace(PLACEHOLDER, $container.dataset.fallback);
            } else {
                $container.innerHTML = $container.innerHTML.replace(PLACEHOLDER, FALLBACK);
            }
        }
    })

    async function getCompany() {
        try {
            const response = await axios.get(API_URL);
            return response;
        } catch (error) {
            console.log(error);
        }
    }
});